import { render, staticRenderFns } from "./managing-broker.vue?vue&type=template&id=697130c9"
import script from "./managing-broker.vue?vue&type=script&lang=js"
export * from "./managing-broker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports